import {
  HttpInterceptorFn
} from '@angular/common/http';

import {
  inject
} from '@angular/core';

import {
  EMPTY
} from 'rxjs';
import { SubscriptionAccessService } from '../services/subscription-access-service';


export const subscriptionInterceptor:
HttpInterceptorFn = (
  req,
  next
) => {

  const subscriptionAccess =
    inject(
      SubscriptionAccessService
    );

  // ==========================================
  // BLOCK PROTECTED APIS
  // ==========================================

  const ignoreUrls = [
    '/contact-sales',
    '/logout',
    '/insights_cube/list_directory',
    '/contact_to_sales'
  ];

  const shouldIgnore =
    ignoreUrls.some(
      url =>
        req.url.includes(url)
    );

  if (
    subscriptionAccess.blocked() &&
    !shouldIgnore
  ) {

    return EMPTY;
  }

  return next(req);
};